import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import Component from '../Component';
/**
 * The pool component allows for [object pooling](https://en.wikipedia.org/wiki/Object_pool_pattern).
 * This gives us a reusable pool of entities to avoid creating and
 * destroying the same kind of entities in dynamic scenes.
 * Object pooling helps reduce garbage collection pauses.
 *
 * Note that entities requested from the pool are paused by default and you need to call `.play()`
 * in order to activate their components’ tick functions.
 *
 * @see https://aframe.io/docs/1.3.0/components/pool.html
 */

export var Pool = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Pool, _Component);

  function Pool() {
    return _Component.apply(this, arguments) || this;
  }

  return Pool;
}(Component);